import { __decorate } from "tslib";
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { netAmount } from '@/types/MultiPayoutTypes';
import { VALIDATION_RULES } from '@/constants/ValidationRules';
import { generateAbo, downloadAbo } from '@/utils/aboGenerator';
let PayoutSummaryStep = class PayoutSummaryStep extends Vue {
    rows;
    loading;
    senderAccount = '';
    senderName = '';
    netAmount = netAmount;
    bankAccountRule = VALIDATION_RULES.BANK_ACCOUNT;
    requiredRule = VALIDATION_RULES.REQUIRED;
    headers = [
        { text: 'Instruktor', value: 'instructorName' },
        { text: 'Číslo účtu', value: 'bankAccount' },
        { text: 'Částka', value: 'amount' },
        { text: 'Daň', value: 'tax' },
        { text: 'Čistá částka', value: 'net', sortable: false },
        { text: 'Zůstatek', value: 'balance', sortable: false },
        { text: 'Zůstatek po', value: 'balanceAfter', sortable: false },
    ];
    getInstructorBalance(instructorId) {
        const active = this.$store.getters['instructor/active'];
        const instructor = active.find(i => i.id === instructorId);
        return instructor ? instructor.data.balance : 0;
    }
    get totalGross() {
        return this.rows.reduce((sum, r) => sum + r.amount, 0);
    }
    get totalTax() {
        return this.rows.reduce((sum, r) => sum + r.tax, 0);
    }
    get totalNet() {
        return Math.round((this.totalGross - this.totalTax) * 100) / 100;
    }
    get isSenderValid() {
        return !!this.senderAccount &&
            this.bankAccountRule(this.senderAccount) === true &&
            !!this.senderName;
    }
    formatCurrency(value) {
        return value.toFixed(2);
    }
    onDownloadAbo() {
        const content = generateAbo(this.rows, this.senderAccount, this.senderName);
        const date = new Date().toISOString().slice(0, 10);
        downloadAbo(content, `vyplata_${date}.abo`);
    }
};
__decorate([
    Prop({ type: Array, required: true })
], PayoutSummaryStep.prototype, "rows", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PayoutSummaryStep.prototype, "loading", void 0);
PayoutSummaryStep = __decorate([
    Component
], PayoutSummaryStep);
export default PayoutSummaryStep;
